<template>
  <div id="app">
    <headerView :seletedindex="seletedindex" />
    <el-menu class="el-menu_img">
      <!-- <div class="container"></div>
      <div class="bannertitle">
        <p class="bannertitle1">{{ newsInformationBanner.title }}</p>
        <p class="bannertitle2">{{ newsInformationBanner.subTitle }}</p>
      </div> -->
      <img
        :src="newsInformationBanner.imgUrl"
        alt
        srcset
        class="index_banner"
        draggable="false"
      />
    </el-menu>
    <div class="news">
      <div class="news_section">
        <span
          v-for="(item, newTypeindex) in newType"
          :key="newTypeindex"
          :class="item.id == active ? 'isactive' : ''"
          @click="selectType(item.id)"
          >{{ item.title }}</span
        >
      </div>
      <div class="newsdetails">
        <div class="news_div">
          <div
            class="news_div_main"
            v-for="(item, index) in newsList"
            :key="index"
            @click="viewDetails(item.id, item.linkUrl,index)"
          >
            <!-- <img :src="item.imgurl" alt srcset class="news_div_img" /> -->
            <img
              :src="item.imgUrl"
              alt
              srcset
              class="news_div_img"
              draggable="false"
            />
            <p class="news_div_p">{{ item.tag }}</p>
            <p class="news_div_p1">
              <span>{{ item.title }}</span>
            </p>
            <!-- <p class="news_div_p2">{{item.subTitle}}</p> -->
            <p class="news_div_p3">
              <span class="news_div_span1">
                <!-- <p>{{item.userName}}</p> -->
                <p>{{ item.addTime }}</p>
              </span>
              <span class="news_div_span2">
                <p class="el-icon-view"></p>
                <p>{{ item.click }}</p>
              </span>
            </p>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        class="pagination"
      ></el-pagination>
    </div>
    <footerView></footerView>
  </div>
</template>
<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, Getnews, getNewsType,changeBrowsingFrequency } from "@/api/index";
import { timeformat } from "@/utils/timeformat";
export default {
  components: { headerView, footerView },
  data() {
    return {
      seletedindex: 4,
      newType: [],
      active: 0,
      total: 0,
      pageindex: 1,
      pageSize: 9,
      typeid: "",
      newsInformationBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      newsList: [],
    };
  },
  created() {
    this.$nextTick(async () => {
      await this.getnewsInformationBanner();
      await this.getType();
      // 检查路由参数，如果有分类ID，则选中对应分类
      const categoryId = this.$route.query.categoryId;
      if (categoryId) {
        const categoryIdNum = parseInt(categoryId);
        if (!isNaN(categoryIdNum)) {
          // 确保分类ID在分类列表中存在
          const categoryExists = this.newType.some(
            (type) => type.id === categoryIdNum
          );
          if (categoryExists) {
            this.active = categoryIdNum;
            this.typeid = categoryIdNum;
          }
        }
      }
      await this.getNewsList();
    });
  },
  methods: {
    handleCurrentChange(index) {
      this.pageindex = index;
      this.getNewsList();
    },
    async getType() {
      const typenews = await getNewsType("/api/zaoying/newsCategories");
      if (typenews.length > 0) {
        this.newType = [{ id: 0, title: "全部" }, ...typenews];
      }
    },
    async getNewsList() {
      const news = await Getnews("/api/zaoying/news", {
        category_id: this.typeid,
        pageNumber: this.pageindex,
        pageSize: this.pageSize,
      });
      if (news && news.items.length > 0) {
        this.total = news.totalRecords;
        this.newsList = [
          ...news.items.map((item) => {
            return {
              id: item.id,
              title: item.title,
              imgUrl: item.imgUrl,
              subTitle: item.subTitle,
              addTime: timeformat(item.addTime),
              click: item.click,
              subTitle: item.subTitle,
              userName: item.userName,
              linkUrl: item.linkUrl,
            };
          }),
        ];
      }
    },
    async getnewsInformationBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 10 });
      if (res.length > 0) {
        this.newsInformationBanner = res[0];
      }
    },
    selectType(index) {
      this.active = index;
      if (index == 0) {
        this.typeid = "";
        // 移除路由参数
        this.$router.replace({
          name: "newsInformation",
        });
      } else {
        this.typeid = index;
        // 更新路由参数
        this.$router.replace({
          name: "newsInformation",
          query: {
            categoryId: index,
          },
        });
      }
      this.getNewsList();
    },
   async viewDetails(id, url,index) {
      const res = await changeBrowsingFrequency("api/zaoying/browse", { id: id });
      this.newsList[index].click += 1;
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: id,
          },
        });
      }
    },
  },
};
</script>
<style scoped>
.el-menu_img {
  width: 100vm;
  height: 25vw;
  z-index: -1;
}

.index_banner {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

/* 容器样式 */
.container {
  z-index: 98;
  position: absolute;
  width: 100%;
  height: 25vw;
  background: linear-gradient(
    to right,
    rgba(115, 104, 98, 0.5),
    rgba(200, 160, 255, 0)
  );
  filter: drop-shadow(10px 10px 20px rgba(47, 77, 132, 0.5));
}
.bannertitle {
  z-index: 99;
  position: absolute;
  height: 660px;
  text-align: left;
  top: 60%;
  left: 8%;
  line-height: 60px;
  color: #fff;
}

.newsmenubtn {
  background-color: #807c7c;
  padding: 8px 0px;
  border-radius: 30px;
}
.bannertitle1 {
  font-size: 38px;
  font-weight: bold;
  letter-spacing: 1px;
}
.bannertitle2 {
  letter-spacing: 3px;
}

.news {
  width: 85%;
  margin: 90px auto 52px auto;
}

.news_section {
}

.news_section span {
  padding: 10px 23px;
  border-radius: 30px;
  margin: 0px 10px;
  border: 1px solid #e5e7eb;
  background-color: #fff;
  cursor: pointer;
  user-select: none;
}

.isactive {
  color: #fff;
  border: none !important;
  background-color: #40b1ff !important;
}

.newsdetails {
  width: 100%;
}

.news_title {
  font-weight: bold;
  font-size: 30px;
  padding: 63px 0px;
}

.news_div {
  width: 100%;
  margin: 50px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  justify-items: left;
}

.news_div:after {
  content: "";
  width: 30%;
  display: block;
  height: 0;
}

.news_div_main {
  min-width: 200px;
  width: 30%;
  line-height: 2;
  margin: 20px 0px;
  border-radius: 15px;
  cursor: pointer;
}

.news_div_img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: fill;
  border-radius: 10px;
}

.news_div_p {
  text-align: left;
  font-size: 15px;
  color: #2563eb;
}

.news_div_p1 {
  text-align: left;
}

.news_div_p1 span {
  font-weight: bold;
  padding: 0px 5px;
  font-size: 20px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news_div_p2 {
  text-align: left;
  padding: 0px 5px;
  color: #4b5563;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.news_div_p3 {
  text-align: left;
  padding: 0px 5px;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.news_div_span1 {
  display: flex;
  align-items: center;
}

.news_div_span1 p {
  padding-right: 20px;
}

.news_div_span2 {
  display: flex;
  align-items: center;
}

.news_div_span2 p {
  padding-left: 5px;
}

.pagination {
  text-align: center;
}
</style>